<template>
	<router-link class="menu-item" :to="path" :title="name" @click="$emit('clicked')">
		{{ name }}
	</router-link>
</template>

<script>

export default {
	props: ['path', 'name'],
	emits: ['clicked'],
}
</script>

<style>
.menu-item {
	border-left: 3px solid #ffffff;
	font-weight: bold;
	font-size: 16px;
	padding: 20px 60px 20px 20px;
	line-height: 21px;
	display: block;
	color: #000;
	border-bottom: 1px solid #EFF1F6;
	border-top: 1px solid #EFF1F6;
}

.menu-item:focus {
	color: unset;
}

.menu-item:hover {
	border-left: 3px solid #f64146;
}
</style>